import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { selectAuthUser } from '../../auth/auth.selectors';
import { User } from '../../administration/user/user.models';
import { CONFIG } from '../../../../config';
import { isNullOrUndefined } from 'util';
import { map, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadConnectionsAction } from './my-connections.actions';
import { selectConnections } from './my-connections.selectors';
import { ConnectionData } from '../../../global/interfaces';

@Component({
  standalone: false,
  selector: 'dsp-my-connections',
  templateUrl: './my-connections.component.html',
  styleUrls: ['./my-connections.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyConnectionsComponent implements OnInit, OnDestroy {
  public user$: Observable<User | undefined>;
  public connections$: Observable<ConnectionData[]>;
  public url: string;
  public loading: any[];

  private readonly subscription: Subscription = new Subscription();
  public profileImageDataUrl$: Observable<any[]> = new Observable<any[]>();
  constructor(
    private readonly store: Store<AppState>,
    private readonly httpClient: HttpClient,
    private readonly domSanitizer: DomSanitizer
  ) {
    this.user$ = this.store.pipe(select(selectAuthUser));
    this.connections$ = this.store.pipe(select(selectConnections));
  }

  ngOnInit() {
    this.store.dispatch(new LoadConnectionsAction());
    this.subscription.add(this.getImageData());
  }
  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getImageData(): Subscription {
    this.url = `${CONFIG.API_URL}/users/getProfileImage/`;
    this.loading = [];
    return this.store.pipe(select(selectConnections)).subscribe(connections => {
      if (!isNullOrUndefined(connections)) {
        connections.forEach(connection => {
          if (!isNullOrUndefined(connection) && !isNullOrUndefined(connection.profileImageId)) {
            this.loading[connection.profileImageId] = true;
            const profileImageUrl = `${this.url}${connection.profileImageId}`;
            this.profileImageDataUrl$[connection.profileImageId] = this.loadImage(profileImageUrl);
          }
        });
      }
    });
  }

  private loadImage(url: any): Observable<any> {
    if (!isNullOrUndefined(url)) {
      return this.httpClient
        // load the image as a blob
        .get(url, { responseType: 'blob', withCredentials: true })
        // create an object url of that blob that we can use in the src attribute
        .pipe(map(e => this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(e))));
    } else {
      return new Observable<any>(null);
    }
  }

  onLoad(id) {
    this.loading[id] = false;
  }
}
